import React from 'react'
import SidebarIcon1 from '../BuisnessDashboard/Images/SidebarIcon1.svg'
import SidebarIcon11 from '../BuisnessDashboard/Images/SidebarIcon11.svg'

import SidebarIcon88 from '../BuisnessDashboard/Images/SidebarIcon88.svg'
import SidebarIcon8 from '../BuisnessDashboard/Images/SidebarIcon8.svg'
import SidebarIcon99 from '../BuisnessDashboard/Images/SidebarIcon99.svg'
import SidebarIcon9 from '../BuisnessDashboard/Images/SidebarIcon9.svg'
import sidbaricon1010 from '../BuisnessDashboard/Images/sidbaricon1010.svg'
import sidbaricon1111 from '../BuisnessDashboard/Images/sidbaricon1111.svg'
import reverseLeadsIcon from '../BuisnessDashboard/Images/reverseLeadsIcon.svg'
import reverseLeadsIcon2 from '../BuisnessDashboard/Images/reverseLeadsIcon2.svg'
import sidbaricon44 from '../BuisnessDashboard/Images/sidbaricon44.svg'
import sidbaricon4 from '../BuisnessDashboard/Images/sidbaricon4.svg'


const SidbarContent = [
    { text: "Dashboard", icon: SidebarIcon11, selectedIcon: SidebarIcon1, ShowType: "dashboard", subType: [] },
    {
        text: "Live Reports", icon: SidebarIcon88, selectedIcon: SidebarIcon8, ShowType: "liveReports", subType: []
    },
    {
        text: "Projections", icon: SidebarIcon99, selectedIcon: SidebarIcon9, ShowType: "projections", subType: []
    },
    {
        text: "Aggregators", icon: sidbaricon1010, selectedIcon: sidbaricon1111, ShowType: "aggregators", subType: []
    },
    {
        text: "Events", icon: reverseLeadsIcon, selectedIcon: reverseLeadsIcon2, ShowType: "events", subType: []
    },
    // {
    //     text: "Reverse Lead", icon: reverseLeadsIcon, selectedIcon: reverseLeadsIcon2, ShowType: "reverseLead", subType: []
    // },
    {
        text: "Campaigns", icon: sidbaricon44, selectedIcon: sidbaricon4, ShowType: "Campaigns", subType: []
    },
]

export default function Sidebar({ handleTabType, isSidebarOpen, activeTab, activeSubTab }) {
    return (
        <>
            <div className='Sidebar-content'>
                <ul className='sidebar-top-level-ul'>
                    {
                        SidbarContent?.length > 0 ? SidbarContent?.map((val, id) => {
                            return (
                                <li style={{ marginBottom: window.innerWidth > 1800 ? "10px" : "" }}>
                                    <div className={`heading ${val?.ShowType == activeTab ? "active" : ""} ${isSidebarOpen ? "expanded" : ""}`} onClick={() => handleTabType(val, "activeTab")}>
                                        <img src={val?.ShowType == activeTab ? val?.selectedIcon : val?.icon} />
                                        <h5 className='sidebar-text'>
                                            {val?.text}
                                        </h5>
                                    </div>
                                    {
                                        val?.ShowType == activeTab && val?.subType?.length > 0 && isSidebarOpen ?
                                            <div className='sub-items'>
                                                <ul>
                                                    {
                                                        val?.subType?.map((subVal, ids) => {
                                                            return (
                                                                <li key={ids}>
                                                                    <div className={`subHeading ${subVal?.ShowType == activeSubTab ? "active" : ""}`} onClick={() => handleTabType(subVal?.ShowType, "activeSubTab")}>
                                                                        <h6>{subVal?.text}</h6>
                                                                    </div>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                            : ""}
                                </li>
                            )
                        })
                            : ""}
                </ul>
            </div>
        </>
    )
}
